import {Component} from '@angular/core';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-niet-aftrekbare-rente',
  templateUrl: './tekst-niet-aftrekbare-rente.component.html',
  styleUrls: ['./tekst-niet-aftrekbare-rente.component.scss'],
})
export class TekstNietAftrekbareRenteComponent {}
